import React, {Component} from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';

import ContactForm from '../../components/Forms/ContactForm';

function mapStateToProps(state) {
   return {
  };
}

function mapDispatchToProps(dispatch) {
  return {
  }
}

class Contact extends Component {

  render() {
    // const { } = this.props;

    return (
      <div className="Contact">
        <div className="column-center column-m">
          <h2>Contact Paige Marie Locke</h2>
          <p>Send me a message and I'll get back to you as soon as I can. Thanks!</p>
          <div className="Contact__contact-form">
            <ContactForm />
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Contact);



// WEBPACK FOOTER //
// ./src/views/Contact/Contact.js